import { useState, useEffect } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Trans } from "@lingui/macro";
import { validateUserBrowsingData } from "@amplio-common/funcs/commonFunctionalities";
import { trackEvent } from "@amplio-common/analytics";


import { css } from "@emotion/react";


const rootStyle = css`
  .notification-message{
    color: red;
    font-weight: bold;
    text-align: center;
  }
`;

const BrowserSupportNotification = () => {
  const [isOpen, setIsOpen] = useState(!validateUserBrowsingData());

  useEffect(() => {
    isOpen && trackEvent("sys_notification_login");
  }, []);

  if (!isOpen) { return null; }

  return (
    <Snackbar
      open={isOpen}
      onClose={() => setIsOpen(false)}
      key="top center"
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      style={{ zIndex: 1501 }}
    >
      <MuiAlert elevation={6} variant="filled" onClose={() => setIsOpen(false)} severity="warning">
        <div css={rootStyle} data-testid="non-google-message">
          <Trans>We recommend using Google Chrome on a computer and Safari on a tablet.</Trans>
        </div>
      </MuiAlert>
    </Snackbar>
  );
};

export default BrowserSupportNotification;
